// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mKhjXKbGj7C8oqX2X5oT{width:100%;height:100%;padding:1rem;background-color:var(--color-background-secondary);border-radius:var(--border-radius-medium)}.Fb8voioyIwHEBSQUuCtJ{margin-bottom:1rem;color:var(--color-text-primary)}.FpJkH7J4H1YTHh4_FYMX{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.LCS67gv4hSDMnMhBpJUH{height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center;overflow:hidden}.LCS67gv4hSDMnMhBpJUH strong{font-weight:500}.KxjS634kQ3mx9WFWZoA0{width:100% !important;max-width:100% !important}.LVhLV5KKr63oOP2S3DYK{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"leftComponent": `mKhjXKbGj7C8oqX2X5oT`,
	"description": `Fb8voioyIwHEBSQUuCtJ`,
	"rightComponent": `FpJkH7J4H1YTHh4_FYMX`,
	"carouselItem": `LCS67gv4hSDMnMhBpJUH`,
	"image": `KxjS634kQ3mx9WFWZoA0`,
	"title": `LVhLV5KKr63oOP2S3DYK`
};
export default ___CSS_LOADER_EXPORT___;
